import { useSelector } from 'react-redux';

import { currentUserSelector } from 'store/modules/auth';

export const useCurrentUser = () => {
  const user = useSelector(currentUserSelector);
  return user;
};
